// extracted by mini-css-extract-plugin
module.exports = {"root":"App_root__2CSG3","pageContent":"App_pageContent__3wwEz","stickyFooter":"App_stickyFooter__2XvfG"};